import {ArrowDropDown, ArrowDropUp} from "@mui/icons-material"
import {Box, Button, ClickAwayListener, MenuItem, MenuList, Paper, Popper, Tooltip} from "@mui/material"
import {useRef, useState} from "react"

import {KeeperPlugin, ReleaseStage} from "../../../../features/node/api/NodeType"
import {EnumOptions, SxPropsMap} from "../../../../shared/helper/HelperType"
import {DbModel, DbModelOptions, KeeperPluginOptions, ReleaseStageOptions} from "../../../../shared/helper/HelperUtils"
import {useStore, useStoreAction} from "../../../../shared/provider/StoreProvider"

const SX: SxPropsMap = {
    group: {display: "flex", alignItems: "stretch", minWidth: 0},
    text: {
        padding: "6px 10px", fontSize: "12px", textTransform: "uppercase", color: "text.primary",
        fontFamily: "monospace", letterSpacing: 1,
        border: "1px solid", borderColor: "divider", borderRight: "none", borderRadius: "4px 0 0 4px",
        minWidth: 0, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", lineHeight: 1,
    },
    arrow: {
        width: "26px", minWidth: "unset", flexShrink: 0, padding: 0,
        borderRadius: "0 4px 4px 0", borderColor: "divider",
    },
    icon: {fontSize: "18px", color: "text.primary"},
    popper: {zIndex: 3},
    menu: {padding: "4px 0px", minWidth: "220px"},
    item: {
        display: "flex", alignItems: "center", gap: 1.5, padding: "5px 10px",
        fontFamily: "monospace", letterSpacing: 1, fontSize: "12px", textTransform: "uppercase",
    },
    label: {flex: "1 1 auto", minWidth: 0, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"},
    model: {flexShrink: 0, width: "72px", textAlign: "right", fontSize: "11px", color: "primary.main"},
    stage: {flexShrink: 0, width: "48px", textAlign: "right", fontSize: "11px", color: "secondary.main"},
}

export function ListKeepers() {
    const keeper = useStore(s => s.activeClusterKeeperPlugin)
    const {setClusterKeeperPlugin} = useStoreAction
    const [open, setOpen] = useState(false)
    const anchorRef = useRef(null)

    const option = KeeperPluginOptions[keeper]

    return (
        <>
            <Box sx={SX.group} ref={anchorRef}>
                <Box sx={SX.text}>{option.label}</Box>
                <Button variant={"outlined"} color={"inherit"} size={"small"} sx={SX.arrow} onClick={() => setOpen(!open)}>
                    {open ? <ArrowDropUp sx={SX.icon}/> : <ArrowDropDown sx={SX.icon}/>}
                </Button>
            </Box>
            <Popper sx={SX.popper} open={open} anchorEl={anchorRef.current} placement={"bottom-start"}>
                <Paper>
                    <ClickAwayListener onClickAway={() => setOpen(false)}>
                        <MenuList sx={SX.menu}>
                            {Object.entries(KeeperPluginOptions).map(([key, value]) => renderItem(key as KeeperPlugin, value))}
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popper>
        </>
    )

    function renderItem(key: KeeperPlugin, value: EnumOptions & {stage: ReleaseStage, model: DbModel}) {
        const itemStage = ReleaseStageOptions[value.stage]
        const itemModel = DbModelOptions[value.model]
        return (
            <MenuItem key={key} sx={SX.item} selected={key === keeper} onClick={() => handleClick(key)}>
                <Box sx={SX.label}>{value.label}</Box>
                <Tooltip title={itemModel.description} placement={"top"}>
                    <Box sx={SX.model}>{itemModel.label.toLowerCase()}</Box>
                </Tooltip>
                <Tooltip title={itemStage.description} placement={"top"}>
                    <Box sx={SX.stage}>{itemStage.label.toLowerCase()}</Box>
                </Tooltip>
            </MenuItem>
        )
    }

    function handleClick(key: KeeperPlugin) {
        setClusterKeeperPlugin(key)
        setOpen(false)
    }
}
